import { loadPurchasedGifts as loadPurchasedGiftsAction } from 'reactApp/modules/purchasedGifts/actions/load.action';
import { updatePurchasedGifts as updatePurchasedGiftsAction } from 'reactApp/modules/purchasedGifts/actions/update.action';

export { loadPurchasedGiftsAction, updatePurchasedGiftsAction };
